import React, { useEffect, useRef, useState } from 'react';
import config from '../config';
import './OurServices.css';
import { useNavigate, useLocation } from 'react-router-dom';
//import FAQ from './FAQ';
import { servicesFaqSchema } from '../schemas/servicesSchema';

const servicesData = [
  {
    id: 1,
    num: '01',
    icon: `${config.paths.testimonials}cfo-icon-website1.jpg.webp`,
    title: "Virtual & Interim CFO Services",
    short: "Senior financial leadership without the overhead of a full-time hire.",
    description: "Work with an experienced Virtual CFO who takes ownership of your finance function — delivering accurate reporting, cash flow control, compliance alignment, and forward-looking strategy. Designed for businesses operating in dynamic regional markets, this service ensures clarity, structure, and accountability through clearly defined deliverables.",
    tag: "Core Service"
  },
  {
    id: 2,
    num: '02',
    icon: `${config.paths.testimonials}asset-256-28.png.webp`,
    title: "E-Invoicing Setup & Compliance",
    short: "Stay prepared for evolving e-invoicing requirements.",
    description: "We support businesses in implementing e-invoicing frameworks aligned with regulatory expectations. From selecting and integrating the right systems to enabling internal teams and maintaining ongoing compliance, our approach ensures a smooth transition with clarity, accuracy, and accountability at every stage.",
    tag: "Compliance"
  },
  {
    id: 3,
    num: '03',
    icon: `${config.paths.testimonials}asset-246-281.png.webp`,
    title: "Company Setup & Winding Down",
    short: "Clear guidance for entity formation and structured exits.",
    description: "Whether launching a new entity in MENA Region — or managing a structured exit — our CFO consultants handle the financial, regulatory, and compliance framework so your business starts or closes on solid footing.",
    tag: "Advisory"
  },
  {
    id: 4,
    num: '04',
    icon: `${config.paths.testimonials}asset-232-28.png.webp`,
    title: "Working Capital Management",
    short: "Improve liquidity and release cash tied up in operations.",
    description: "Our specialists assess your receivables, payables, and inventory cycles to identify inefficiencies and unlock cash within the business. Through practical, data-driven strategies, we enhance liquidity, streamline operations, and provide leadership with clearer, real-time visibility over working capital performance.",
    tag: "Optimization"
  },
  {
    id: 5,
    num: '05',
    icon: `${config.paths.testimonials}asset-237-281.png.webp`,
    title: "M&A and Fundraising",
    short: "Deal advisory and capital support for growth-focused businesses.",
    description: "We support organizations through every stage of capital raising and transaction execution — from structuring investment rounds and preparing investor-ready financials to managing due diligence and facilitating cross-border deals. Our approach brings the financial discipline and clarity needed to move opportunities forward with confidence.",
    tag: "Growth"
  },
  {
    id: 6,
    num: '06',
    icon: `${config.paths.testimonials}asset-235-281.png.webp`,
    title: "IPO Readiness",
    short: "Build a finance function ready for regional stock exchanges.",
    description: "Preparing for a public listing requires robust financial controls, transparent reporting, and a compelling growth story. Our CFO specialists partner with leadership teams to develop IPO-ready finance structures, investor presentations, and prospectus-level disclosures, ensuring your company meets the expectations of ADX, DFM, and other regional exchanges with confidence and credibility.",
    tag: "Capital Markets"
  },
  {
    id: 7,
    num: '07',
    icon: `${config.paths.testimonials}asset-244-281_png.webp`,
    title: "ERP Implementation",
    short: "Seamless ERP solutions for UAE and GCC businesses.",
    description: "We support organizations through every stage of ERP adoption — from choosing the platform that fits your business needs to system configuration, data migration, and post-implementation optimization. Our approach ensures your technology investment drives operational efficiency, financial clarity, and measurable business value across MENA Operations.",
    tag: "Technology"
  },
  {
    id: 8,
    num: '08',
    icon: `${config.paths.testimonials}asset-253-28_png1.webp`,
    title: "AML, Corporate Tax & VAT",
    short: "Comprehensive tax and AML compliance across MENA regions.",
    description: "Stay fully compliant with UAE Corporate Tax, VAT, and Anti-Money Laundering regulations. Our specialists handle tax registration, filings, and ongoing reporting while designing AML frameworks that meet UAE Central Bank and regulatory standards — providing peace of mind and operational certainty across the region.",
    tag: "Compliance"
  },
];


/* ─────────────────────────────────────────────
   CHANGE THIS LINE to swap the hero banner image
   Use any filename from your /banners/ folder
───────────────────────────────────────────── */
const HERO_BANNER = `${config.imageBaseURL}${config.paths.banners}uae-cfobridge4.webp`;

const ServiceCard = ({ service, index }) => {
  const [hovered, setHovered] = useState(false);
  const cardRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className={`svc-card ${visible ? 'svc-card--visible' : ''}`}
      style={{ transitionDelay: `${(index % 3) * 80}ms` }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="svc-card__num">{service.num}</div>
      <div className="svc-card__body">
        <div className="svc-card__icon">
          <img
            src={service.icon}
            alt={service.title}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
        <h3 className="svc-card__title">{service.title}</h3>
        <p className="svc-card__short">{service.short}</p>
        <p className={`svc-card__desc ${hovered ? 'svc-card__desc--show' : ''}`}>
          {service.description}
        </p>
      </div>
      <div className="svc-card__footer">
        <span className="svc-card__tag">{service.tag}</span>
        <div className="svc-card__line"></div>
      </div>
    </div>
  );
};

const PRONGED_IMAGE = `${config.imageBaseURL}${config.paths.img}5-progled.png`;
const Services = () => {
  const [heroVisible, setHeroVisible] = useState(false);
  const navigate = useNavigate();
const location = useLocation();

  useEffect(() => {
    setHeroVisible(true);
  }, []);

  return (
    <div className="svc-page">

      {/* ── Hero Banner ── */}
      <div
        className={`svc-hero ${heroVisible ? 'svc-hero--visible' : ''}`}
        style={{ backgroundImage: `url(${HERO_BANNER})` }}
      >
        <div className="svc-hero__overlay" />
        <div className="svc-hero__inner">
          <div className="svc-hero__eyebrow">
            <span className="svc-hero__line" />
            <span>CFO Bridge UAE</span>
            <span className="svc-hero__line" />
          </div>
          <h1 className="svc-hero__title">
            Financial Leadership<br />
            <em>On Demand</em>
          </h1>
          <p className="svc-hero__sub">
            Expert CFO services tailored for businesses in the UAE — from compliance and strategy to transformation and growth.
          </p>
          <a href="/#contact"
  className="svc-btn-primary"
  onClick={(e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
      return;
    }
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }}
>
  <span className="svc-btn-primary__text">Schedule a Consultation</span>
  <span className="svc-btn-primary__arrow">→</span>
</a>
        </div>
      </div>

      {/* ── Cards Grid ── */}
      {/* ── Cards Grid ── */}
<div className="svc-grid-section">
  <div className="svc-grid-wrap">
    <div className="svc-section-head">
      <h2 className="svc-section-title">CFO Services that Make Us Unique</h2>
      <p className="svc-section-sub">
        CFO Bridge UAE offers tailored financial leadership through expert Virtual CFO and Fractional CFO services — giving businesses the flexibility to access top-tier expertise without the cost of a full-time CFO.
      </p>
    </div>

    {/* Row 1 — first 6 cards in 3 columns */}
    <div className="svc-grid svc-grid-row1">
      {servicesData.slice(0, 6).map((service, index) => (
        <ServiceCard key={service.id} service={service} index={index} />
      ))}
    </div>

    {/* Row 2 — last 2 cards, centered */}
    <div className="svc-grid svc-grid-row2">
      {servicesData.slice(6).map((service, index) => (
        <ServiceCard key={service.id} service={service} index={index + 6} />
      ))}
    </div>
  </div>
</div>
      
      {/* ── 5-Pronged Approach ── */}
<div className="svc-pronged-section">
  <div className="svc-pronged-wrap">
    <div className="svc-section-head">
      <h2 className="svc-section-title">Our 5-Pronged Approach</h2>
      <p className="svc-section-sub">
        CFO Bridge follows a 5-pronged framework to ensure good financial
        management and decision making.
      </p>
    </div>

    
    <a href="https://youtu.be/xO2StpCJCCI?si=L-Q2ifFw4zU0Bqoa"
  target="_blank"
  rel="noopener noreferrer"
  className="svc-pronged-thumb"
  aria-label="Watch our 5-Pronged Approach video"
  style={{ position: 'relative', display: 'block', overflow: 'hidden' }}
>
  {/* Background image — falls back to dark bg if path fails */}
  <img
  src={PRONGED_IMAGE}
  alt="CFO Bridge 5-Pronged Approach"
  className="svc-pronged-img"
  style={{ display: 'block', width: '100%', objectFit: 'cover' }}
  // Remove onError entirely for now
/>

  {/* Blue vignette overlay */}
  <div
    className="svc-pronged-overlay"
    style={{
      position: 'absolute', inset: 0,
      background: 'linear-gradient(to top, rgba(1,66,147,0.75) 0%, rgba(0,0,0,0.15) 60%)',
      pointerEvents: 'none',
    }}
  />

  {/* Play button */}
  <div
    className="svc-pronged-play"
    aria-hidden="true"
    style={{
      position: 'absolute', top: '50%', left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 72, height: 72,
      pointerEvents: 'none',
    }}
  >
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" r="28" fill="rgba(1,66,147,0.85)" />
      <polygon points="22,17 42,28 22,39" fill="#ffffff" />
    </svg>
  </div>

  {/* Bottom label */}
  <div
    className="svc-pronged-label"
    style={{
      position: 'absolute', bottom: 0, left: 0, right: 0,
      padding: '16px 24px',
      pointerEvents: 'none',
    }}
  >
    <span className="svc-pronged-label__eyebrow">Watch the video</span>
    <span className="svc-pronged-label__title">The 5-Pronged Approach</span>
  </div>
</a>
  </div>
</div>

      {/* ── FAQ Section ── 
<FAQ faqs={servicesFaqSchema.mainEntity.map(q => ({
  heading: q.name,
  description: q.acceptedAnswer.text
}))} />*/}

      {/* ── CTA Strip ── */}
<div className="svc-cta-strip">
  <div className="svc-cta-strip__inner">
    <p className="svc-cta-strip__text">Not sure which service fits your needs?</p>
    
      <a href="/#contact"
      className="svc-cta-strip__btn"
      onClick={(e) => {
        e.preventDefault();
        if (location.pathname !== '/') {
          navigate('/');
          setTimeout(() => {
            const el = document.getElementById('contact');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
          return;
        }
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }}
    >
      Schedule a Free Consultation
      <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 10h12M10 4l6 6-6 6" />
      </svg>
    </a>
  </div>
</div>

    </div>
  );
};

export default Services;